module.exports = __webpack_public_path__ + "assets/img/logo-white.52bd9c18.png";